import { mapState } from 'vuex'
import ClientContractCard from '@/components/client/contract/card/ClientContractCard.vue'
import SummaryPlacedSimple from '@/components/reports/summaryplacedsimple/SummaryPlacedSimple.vue'

export default {
  name: 'ClientListExpand',
  props: {
    data: Object
  },
  components: {
    ClientContractCard,
    SummaryPlacedSimple
  },
  computed: {
    ...mapState(['config']),
    enabledContracts () {
      if (this.data && this.data.active_contracts) {
        return this.data.active_contracts.filter(el => !el.disabled);
      }
      return [];
    },
    isD365BillingEnabled () {
      return !!this.BasicHelper.getObjectValueByString(this.config, 'plugins.d365_api.enabled');
    },
    clientTotalBalance () {
      if (this.isD365BillingEnabled) {
        return parseFloat(this.data.balanceAdvanceBill || 0) + parseFloat(this.data.d365Balance || 0);
      }
      return parseFloat(this.data.balance || 0) + parseFloat(this.data.balanceAdvanceBill || 0) + parseFloat(this.data.balanceOpenOrders || 0);
    }
  },
  methods: {
    simulateUser (el, approved = false) {
      if (approved) {
        this.ApiRequest.simulateUser(el, this);
      } else {
        this.$refs.userSimulateMsgBox.show(el, this.$t('user.simulate.title'), this.$t('user.simulate.message', { userName: el.name, email: el.email }))
      }
    }
  }
}
